import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import HeaderRec from '../../header/headerRec';
import '../Mission/AllMissions.css';
import axios from 'axios';
import SharePopup from '../../commun/SharePopup';
import TableFilterControls from '../../commun/TableFilterControls';
import MissionCard from './MissionCard';
import Pagination from '../../commun/Pagination';
import Chatbox from '../../commun/ChatBox';
import Footer from '../../commun/Footer';
import MissionCardList from './MissionCardList';
import { TextField } from '@mui/material';
import StatusTabs from '../../commun/StatusTabs';

const AllMissions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [missions, setMissions] = useState([]);
  // const [filteredMissions, setFilteredMissions] = useState([]);
  const [favorites, setFavorites] = useState([]);
  const [selectedMission, setSelectedMission] = useState(null);
  const [expandedMissionId, setExpandedMissionId] = useState(null);
  const [readMissions, setReadMissions] = useState([]);
  const [dateFilter, setDateFilter] = useState('all');
  const [statusFilter, setStatusFilter] = useState('all');
  const [viewMode, setViewMode] = useState('grid');
  const [sortStatus, setSortStatus] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');

  const [page, setPage] = useState(1);
  const itemsPerPage = 11;

  const isFavoritesPage = location.pathname === '/recruteur/favoris';
  const isMyMissionsPage = location.pathname === '/recruteur/Mesmissions';

  const recruteurName = localStorage.getItem("recruteurName");
  const authToken = localStorage.getItem("authToken");
  const userId = localStorage.getItem("userId");
  const API_BASE = process.env.REACT_APP_API_BASE_URL;


  useEffect(() => {
  if (isFavoritesPage ) {
    fetchFavoritesMissions();
  }
}, [isFavoritesPage]);

// Charger les missions favorites dès le chargement, pour tous les cas
useEffect(() => {
  const loadFavorites = async () => {
    try {
      const res = await axios.get(`${API_BASE}/api/recruteur`, {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { userId }
      });
      setFavorites(res.data.map(m => m._id));
    } catch (err) {
      console.error('❌ Erreur lors du chargement des favoris initiaux:', err);
    }
  };

  loadFavorites();
}, [authToken, userId]);

  useEffect(() => {
    const token = localStorage.getItem('authToken');
    if (!token) {
      navigate('/');
      return;
    }

    const loadAll = async () => {
      try {
        const readRes = await axios.get(`${API_BASE}/api/recruteur/read-missions/${userId}`, {
          headers: { Authorization: `Bearer ${authToken}` }
        });
        const readIds = readRes.data.map(r => r.missionId || r._id || r).filter(Boolean);
        setReadMissions(readIds);

        let missionsData = [];

        if (isFavoritesPage || isMyMissionsPage) {
          const endpoint = isFavoritesPage
            ? `${API_BASE}/api/recruteur`
            : `${API_BASE}/api/candidatures/mes-missions/${userId}`;

          const missionRes = await axios.get(endpoint, {
            headers: { Authorization: `Bearer ${authToken}` },
            params: isFavoritesPage ? { userId } : undefined,
          });

          const rawData = missionRes.data;
          const formatted = await Promise.all(rawData.map(m => formatMission(m, readIds)));
          setMissions(formatted);

          if (isFavoritesPage) {
            setFavorites(rawData.map(m => m._id));
          }
        } else {
          const allMissionsRes = await axios.get(`${API_BASE}/api/missions/all`);
          const formatted = await Promise.all(allMissionsRes.data.map(m => formatMission(m, readIds)));
          setMissions(formatted);
        }
      } catch (err) {
        console.error("❌ Erreur dans le chargement complet:", err);
      }
    };

    loadAll();
  }, [navigate, isFavoritesPage, isMyMissionsPage]);

  useEffect(() => {
    const now = new Date();
    let filtered = missions;

    if (dateFilter !== 'all') {
      filtered = filtered.filter((m) => {
        const createdAt = new Date(m.createdAt);
        if (dateFilter === 'today') return createdAt.toDateString() === now.toDateString();
        if (dateFilter === 'week') {
          const weekAgo = new Date();
          weekAgo.setDate(now.getDate() - 7);
          return createdAt >= weekAgo;
        }
        if (dateFilter === 'month') {
          const monthAgo = new Date();
          monthAgo.setMonth(now.getMonth() - 1);
          return createdAt >= monthAgo;
        }
        return true;
      });
    }

    if (statusFilter !== 'all') {
      filtered = filtered.filter(m => m.status === statusFilter);
    }

    // setFilteredMissions(filtered);
    setPage(1);
  }, [missions, dateFilter, statusFilter]);

  const filteredMissions = missions
  .filter((m) =>
    (!sortStatus || m.status === sortStatus) &&
    m.nomMission?.toLowerCase().includes(searchTerm.toLowerCase())
  );
  const missionsPerPage = 5;
  const paginated = filteredMissions.slice((page - 1) * missionsPerPage, page * missionsPerPage);

  const formatMission = async (mission, readList = []) => {
    const createdAt = new Date(mission.createdAt);
    const isNew = !readList.includes(mission._id);

    let recrutéCount = 0;
    try {
      const res = await axios.get(`${API_BASE}/api/candidatures/recruted-count/${mission._id}`);
      recrutéCount = res.data.count;
    } catch (err) {
      console.error('❌ Erreur recrutés:', err);
    }

    return {
      ...mission,
      isNew,
      createdAt,
      logoUrl: mission.logo,
      company: mission.NomEntreprise || 'Entreprise inconnue',
      title: mission.nomMission,
      reward: mission.remuneration,
      description: mission.contexteMission || 'Pas de description fournie.',
      date: createdAt.toLocaleDateString('fr-FR'),
      location: mission.lieuxTravail || 'Non spécifié',
      availableSpots: `${recrutéCount} / ${mission.placesDispo ?? 'N/A'}`,
      candidates: mission.candidatsProposes || 0,
      topMatches: mission.topMatches || 0,
      prime: `${mission.prime || 0} €`,
      garantie: `${mission.garantie || 1} mo.`
    };
  };

const toggleFavorite = async (missionId) => {
  try {
    await axios.post(
      `${API_BASE}/api/recruteur/favorites/${missionId}`,
      {},
      {
        headers: { Authorization: `Bearer ${authToken}` },
        params: { userId }
      }
    );

    // Recharge les favoris à chaque modification
    const res = await axios.get(`${API_BASE}/api/recruteur`, {
      headers: { Authorization: `Bearer ${authToken}` },
      params: { userId }
    });
    setFavorites(res.data.map(m => m._id));

    if (isFavoritesPage) {
      fetchFavoritesMissions();
    }

  } catch (err) {
    console.error('❌ Erreur favori:', err);
  }
};

  const fetchFavoritesMissions = async () => {
  try {
    const readRes = await axios.get(`${API_BASE}/api/recruteur/read-missions/${userId}`, {
      headers: { Authorization: `Bearer ${authToken}` }
    });
    const readIds = readRes.data.map(r => r.missionId || r._id || r).filter(Boolean);
    setReadMissions(readIds);

    const res = await axios.get(`${API_BASE}/api/recruteur`, {
      headers: { Authorization: `Bearer ${authToken}` },
      params: { userId }
    });

    const data = await Promise.all(res.data.map(m => formatMission(m, readIds)));
    setMissions(data);
    setFavorites(data.map(m => m._id));
  } catch (err) {
    console.error('❌ Erreur fetchFavoritesMissions :', err);
  }
};

  const toggleExpand = (id) => {
    setExpandedMissionId(prev => (prev === id ? null : id));
  };

  const handleView = async (id) => {
    try {
      await axios.post(
        `${API_BASE}/api/recruteur/mark-read/${userId}`,
        { missionId: id },
        { headers: { Authorization: `Bearer ${authToken}` } }
      );
      setReadMissions(prev => [...new Set([...prev, id])]);
    } catch (err) {
      console.error("❌ Erreur mission lue:", err);
    }
    navigate(`/Recruteur/Details/${id}`);
  };

  return (
    <div className="recruteurM-page">
      <HeaderRec recruteurName={recruteurName} authToken={authToken} userId={userId} />
      <h2 className="missions-title">
        {isFavoritesPage ? 'Mes favoris' : isMyMissionsPage ? 'Mes missions' : 'Toutes les missions'}
      </h2>
        <div className="filters-section-horizontal">
          <TextField
            label="Recherche"
            variant="outlined"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="search-bar"
          />

          <StatusTabs
            statuses={{
              active: missions.filter((m) => m.status === 'active'),
              inactive: missions.filter((m) => m.status === 'inactive'),
            }}
            activeStatus={sortStatus}
            onStatusChange={(newStatus) => setSortStatus(newStatus)}
            userRole="entreprise"
            statusStylesSource={[
              { value: 'active', label: 'PUBLIÉE', style: { backgroundColor: '#2e7d32', color: '#fff' } },
              { value: 'inactive', label: 'INACTIVE', style: { backgroundColor: '#d32f2f', color: '#fff' } },
            ]}
            labelMapping={{
              active: 'PUBLIÉE',
              inactive: 'INACTIVE'
            }}
          />
        </div>

      <div className="filters-container">
        <div className="view-toggle-container">
          <span className="toggle-label">Affichage :</span>
          <button
            className={`view-toggle-btn ${viewMode === 'grid' ? 'active' : ''}`}
            onClick={() => setViewMode('grid')}
          >
            ▦ Grille
          </button>
          <button
            className={`view-toggle-btn ${viewMode === 'list' ? 'active' : ''}`}
            onClick={() => setViewMode('list')}
          >
            ≡ Liste
          </button>
        </div>
      </div>

      <div className={`missions-container ${viewMode === 'list' ? 'list-view' : ''}`}>
        {filteredMissions
  .slice((page - 1) * itemsPerPage, page * itemsPerPage)
  .map((mission) =>
    viewMode === 'grid' ? (
      <MissionCard
        key={mission._id}
        mission={mission}
        isFavorite={favorites.includes(mission._id)}
        onToggleFavorite={toggleFavorite}
        onExpand={toggleExpand}
        onView={handleView}
        onShare={setSelectedMission}
        expanded={expandedMissionId === mission._id}
        viewMode={viewMode}
      />
    ) : (
      <MissionCardList
        key={mission._id}
        mission={mission}
        isFavorite={favorites.includes(mission._id)}
        onToggleFavorite={toggleFavorite}
        onView={handleView}
        onShare={setSelectedMission}
      />
    )
  )}

      </div>

      <Pagination
        page={page}
        setPage={setPage}
        totalItems={filteredMissions.length}
        itemsPerPage={itemsPerPage}
      />

      {selectedMission && (
        <SharePopup
          shareUrl={`${process.env.REACT_APP_FRONTEND_BASE_URL}/Recruteur/Details/${selectedMission._id}`}
          onClose={() => setSelectedMission(null)}
        />
      )}

      <Chatbox userRole="recruteur" />
      <Footer />
    </div>
  );
};

export default AllMissions;
